import { LOCALES, KEYS } from '../constants';

const zhCNTranslations = Object.freeze({
  [LOCALES.L18N_LOCALE_CHINESE_CN] : {
    [KEYS.L18N_KEY_LABEL_PARTNER_ROLE ]:"合作伙伴角色",
    [KEYS.L18N_KEY_LABEL_INTEGRATOR ]:"集成商",
    [KEYS.L18N_KEY_LABEL_PROVIDER ]:"提供商",
    [KEYS.L18N_KEY_LABEL_PARTNER_LEVEL]:"合作伙伴级别",
    [KEYS.L18N_KEY_LABEL_PARTNER_SPECIALIZATION ]:"合作伙伴专业化认证",
    [KEYS.L18N_KEY_LABEL_CISCO_POWERED_SERVICE ]:" Cisco Powered 服务",
    [KEYS.L18N_KEY_LABEL_PARTNER_NAME ]:"合作伙伴名称",
    [KEYS.L18N_KEY_LABEL_LOCATION ]:"位置",
    [KEYS.L18N_KEY_LABEL_COUNTRY ]:"国家/地区",
    [KEYS.L18N_KEY_LABEL_PARTNER_NAME_KEYWORD ]:"合作伙伴名称关键字",
    [KEYS.L18N_KEY_LABEL_PARTNER_NAME_KEYWORD_S_ ]:"合作伙伴名称关键字",
    [KEYS.L18N_KEY_LABEL_SORTING ]:"排序",
    [KEYS.L18N_KEY_LABEL_SPECIALIZATIONS ]:"专业化认证",
    [KEYS.L18N_KEY_LABEL_PARTNER_SPECIALIZATIONS ]:"合作伙伴专业化认证",
    [KEYS.L18N_KEY_LABEL_PROVIDER_LEVEL_AND_CISCO_POWERED_SERVICES ]:"提供商级别和 Cisco Powered 服务",
    [KEYS.L18N_KEY_LABEL_GOLD_PROVIDER ]:"金牌提供商",
    [KEYS.L18N_KEY_LABEL_PREMIER_PROVIDER ]:"高级提供商",
    [KEYS.L18N_KEY_LABEL_SELECT_PROVIDER ]:"优选提供商",
    [KEYS.L18N_KEY_LABEL_ELOQUA__GET_GUIDANCE]:"获取指导",
    [KEYS.L18N_KEY_LABEL_ELOQUA__REQUEST_A_QUOTE ]:"请求报价",
    [KEYS.L18N_KEY_LABEL_OPEN ]:"开放式",
    [KEYS.L18N_KEY_LABEL_EXPAND ]:"展开",
    [KEYS.L18N_KEY_LABEL_COLLAPSE ]:"折叠",
    [KEYS.L18N_KEY_LABEL_CHOOSE_A_COUNTRY ]:"选择国家/地区",
    [KEYS.L18N_KEY_LABEL_CHOOSE_A_ROLE ]:"选择角色",
    [KEYS.L18N_KEY_LABEL_CHOOSE_SPECIALIZATION_S_ ]:"选择专业化认证",
    [KEYS.L18N_KEY_LABEL_CHOOSE_CISCO_POWERED_SERVICE_S_ ]:"选择 Cisco Powered 服务",
    [KEYS.L18N_KEY_LABEL_CHOOSE_EXPERTISE_S]:"选择专业知识",
    [KEYS.L18N_KEY_LABEL_CHOOSE_LEVEL_S_ ]:"选择级别",
    [KEYS.L18N_KEY_LABEL_PARTNER_COUNTRY ]:"合作伙伴国家/地区",
    [KEYS.L18N_KEY_LABEL_INTEGRATOR_LEVELS ]:"集成商级别",
    [KEYS.L18N_KEY_LABEL_PROVIDER_LEVELS ]:"提供商级别",
    [KEYS.L18N_KEY_LABEL_INTEGRATOR_SPECIALIZATIONS ]:"集成商专业化认证",
    [KEYS.L18N_KEY_LABEL_CISCO_POWERED_SERVICES ]:"Cisco Powered 服务",
    [KEYS.L18N_KEY_LABEL_PARTNER_NAMES ]:"合作伙伴名称",
    [KEYS.L18N_KEY_LABEL_BACK ]:"上一页",
    [KEYS.L18N_KEY_LABEL_ALL_RESULTS]:"所有结果",
    [KEYS.L18N_KEY_LABEL_ALL ]:"全部",
    [KEYS.L18N_KEY_LABEL_SAVED ]:"已保存",
    [KEYS.L18N_KEY_LABEL_MY_PARTNERS ]:"我的合作伙伴",
    [KEYS.L18N_KEY_LABEL_ADD ]:"添加",
    [KEYS.L18N_KEY_LABEL_REMOVE ]:"删除",
    [KEYS.L18N_KEY_LABEL_ADD_TO_COMPARE ]:"添加到比较项 ",
    [KEYS.L18N_KEY_LABEL_SELECT_AT_LEAST_ONE_MORE ]:"请至少选择一项",
    [KEYS.L18N_KEY_LABEL_COMPARE_SELECTED ]:"比较选定项 ",
    [KEYS.L18N_KEY_LABEL_REMOVE_FROM_COMPARATOR ]:"从比较工具中移除",
    [KEYS.L18N_KEY_LABEL_COMPARE ]:"对比",
    [KEYS.L18N_KEY_LABEL_PARTNER_LEVEL ]:"合作伙伴级别",
    [KEYS.L18N_KEY_LABEL_PROCESSING_IN_PROGRESS]:"正在处理",
    [KEYS.L18N_KEY_LABEL_RESULT ]:"个结果",
    [KEYS.L18N_KEY_LABEL_RESULTS ]:"个结果",
    [KEYS.L18N_KEY_LABEL_NO_RESULTS ]:"无结果",
    [KEYS.L18N_KEY_LABEL_RESULT_IN]:"结果：",
    [KEYS.L18N_KEY_LABEL_RESULTS_IN]:"结果：",
    [KEYS.L18N_KEY_LABEL_NO_RESULTS_IN]:"无结果：",
    [KEYS.L18N_KEY_LABEL_PREVIOUS ]:"上一页",
    [KEYS.L18N_KEY_LABEL_PREV ]:"上一页",
    [KEYS.L18N_KEY_LABEL_NEXT ]:"下一页",
    [KEYS.L18N_KEY_LABEL_SAVE ]:"保存",
    [KEYS.L18N_KEY_LABEL_EXPERTISE ]:"专业知识",
    [KEYS.L18N_KEY_LABEL_OVERVIEW ]:"概述",
    [KEYS.L18N_KEY_LABEL_IS_A_CISCO ]:"是思科",
    [KEYS.L18N_KEY_LABEL_ROLE_INTEGRATOR_DESCRIPTION]:"集成商负责为我们的客户构建端到端解决方案。他们主要通过转售方式达成交易，但他们也能利用自身独特的专业知识帮助客户解决业务问题",
    [KEYS.L18N_KEY_LABEL_ROLE_PROVIDER_DESCRIPTION ]:"提供商是提供托管和云解决方案的专家。客户希望更灵活地使用解决方案，而提供商在市场中的重要性也日益突出。",
    [KEYS.L18N_KEY_LABEL_PAST_SEARCHES ]:"历史搜索",
    [KEYS.L18N_KEY_LABEL_PAST_SEARCH ]:"历史搜索",
    [KEYS.L18N_KEY_LABEL_ROLES ]:"角色 ",
    [KEYS.L18N_KEY_LABEL_TECHNOLOGY ]:"技术",
    [KEYS.L18N_KEY_LABEL_INDUSTRIES ]:"行业",
    [KEYS.L18N_KEY_LABEL_INTEGRATORS ]:"集成商",
    [KEYS.L18N_KEY_LABEL_PROVIDERS ]:"提供商",
    [KEYS.L18N_KEY_LABEL_OTHER ]:"其他",
    [KEYS.L18N_KEY_LABEL_OTHERS ]:"其他",
    [KEYS.L18N_KEY_LABEL_NO_SAVED_OTHER_PARTNERS]:"没有已保存的其他合作伙伴",
    [KEYS.L18N_KEY_LABEL_NO_SAVED_INTEGRATORS ]:"没有已保存的集成商",
    [KEYS.L18N_KEY_LABEL_NO_SAVED_PROVIDERS ]:"没有已保存的提供商",
    [KEYS.L18N_KEY_LABEL_FILTER_BY_NEED ]:"根据需要筛选",
    [KEYS.L18N_KEY_LABEL_SEARCH_BY_COMBINED_CRITERIA ]:"按组合条件搜索",
    [KEYS.L18N_KEY_LABEL_SEARCH_BY_LOCATION ]:"按位置搜索",
    [KEYS.L18N_KEY_LABEL_THERE_IS_ONE_PARTNER_SERVING_WORLDWIDE]:"找到 1 个提供全球服务的合作伙伴",
    [KEYS.L18N_KEY_LABEL_THERE_ARE]:"找到",
    [KEYS.L18N_KEY_LABEL_PARTNERS_SERVING_WORLDWIDE]:"个提供全球服务的合作伙伴",
    [KEYS.L18N_KEY_LABEL_THERE_ARE_ONE_NO_PARTNERS_SERVING]:"未找到提供服务的合作伙伴",
    [KEYS.L18N_KEY_LABEL_THERE_IS_ONE_PARTNER_SERVING_IN]:"找到 1 个提供服务的合作伙伴：",
    [KEYS.L18N_KEY_LABEL_PARTNERS_SERVING_IN]:"个提供服务的合作伙伴：",
    [KEYS.L18N_KEY_LABEL_THERE_ARE_ONE_PARTNERS_SERVING_IN]:"找不到提供服务的合作伙伴：",
    [KEYS.L18N_KEY_LABEL_CHANGE_LOCATION]:"更改位置",
    [KEYS.L18N_KEY_LABEL_FILTER_BY_NEED]:"根据需要筛选",
    [KEYS.L18N_KEY_LABEL_SEARCH]:"搜索",
    [KEYS.L18N_KEY_LABEL_BY_NAME_ONE_LEVEL_AND_EXPERTISE]:"按名称、级别和专业知识",
    [KEYS.L18N_KEY_LABEL_SELECTED]:"已选择",
    [KEYS.L18N_KEY_LABEL_NO_MATCHES_FOUND]:"未找到匹配项",
    [KEYS.L18N_KEY_LABEL_RANK_UP]:"级别升序排列",
    [KEYS.L18N_KEY_LABEL_RANK_DOWN]:"级别降序排列",
    [KEYS.L18N_KEY_LABEL_NAME_UP]:"名称升序排列",
    [KEYS.L18N_KEY_LABEL_NAME_DOWN]:"名称降序排列",
    [KEYS.L18N_KEY_LABEL_LOGIN_REQUIRED]:"需要登录",
    [KEYS.L18N_KEY_LABEL_YOU_MUST_ONE_PERFORM_THIS_ACTION]:"必须登录才能执行此操作",
    [KEYS.L18N_KEY_LABEL_SEARCH_RESTORATION_FAILED]:"搜索恢复失败",
    [KEYS.L18N_KEY_LABEL_LOG_IN]:"登录",
    [KEYS.L18N_KEY_LABEL_PARTNER_SUCCESSFULLY_SAVED]:"已成功保存合作伙伴",
    [KEYS.L18N_KEY_LABEL_THE_PARTNER_ONE_NOT_BE_SAVED]:"无法保存合作伙伴",
    [KEYS.L18N_KEY_LABEL_PARTNER_SUCCESSFULLY_REMOVED]:"已成功删除合作伙伴",
    [KEYS.L18N_KEY_LABEL_THE_PARTNER_ONE_NOT_BE_DELETED]:"无法删除合作伙伴",
    [KEYS.L18N_KEY_LABEL_TYPE_A_ONE_LEVEL_OR_EXPERTISE]:"请输入关键字，按名称、级别和专业知识搜索",
    [KEYS.L18N_KEY_LABEL_ROLE_DEVELOPER_DESCRIPTION]:"开发者是以思科技术为基础构建个性化软件和硬件解决方案的专家，致力于打造独特的解决方案来实现系统整合，帮助客户取得所需的成果。",
    [KEYS.L18N_KEY_LABEL_ROLE_ADVISOR_DESCRIPTION]:"顾问是具有深厚行业知识的专家，负责指导企业成功找到应对复杂业务挑战所需的解决方案。",
    [KEYS.L18N_KEY_LABEL_DIVERSE_PARTNER]:"多元化合作伙伴",
    [KEYS.L18N_KEY_LABEL_ALPHABETICAL]:"按字母顺序",
    [KEYS.L18N_KEY_LABEL_MOST_EXPERTISE]:"最深厚的专业知识",
    [KEYS.L18N_KEY_LABEL_DEVELOPER]:"开发者",
    [KEYS.L18N_KEY_LABEL_ADVISOR]:"顾问",

    [KEYS.L18N_KEY_LABEL_FILTERS]:"过滤器",
    [KEYS.L18N_KEY_LABEL_FILTER_VERB]:"过滤器",
    [KEYS.L18N_KEY_LABEL_PARTNER_EXPERTISE]:"合作伙伴专业知识",
    [KEYS.L18N_KEY_LABEL_DISMISS_VERB]:"解除",
    [KEYS.L18N_KEY_LABEL_SPECIALIZATION]:"专业化认证",
    [KEYS.L18N_KEY_LABEL_EXPERTISES]:"专业知识",
    [KEYS.L18N_KEY_LABEL_NO_DESCRIPTION_PROVIDED_DOT]:"未提供描述。",
    [KEYS.L18N_KEY_LABEL_ABOUT]:"关于",
    [KEYS.L18N_KEY_LABEL_CLEAR_COMPARATOR]:"清除比较项",
    [KEYS.L18N_KEY_LABEL_PARTNER_COMPARISON]:"合作伙伴比较",
    [KEYS.L18N_KEY_LABEL_ROLE]:"角色",
    [KEYS.L18N_KEY_LABEL_TECHNOLOGICAL_FOCUS]:"技术重点",
    [KEYS.L18N_KEY_LABEL_DESCRIPTION]:"说明",
    [KEYS.L18N_KEY_LABEL_CHOOSE_LANGUAGE_SELECTION]:"选择语言选项",
    [KEYS.L18N_KEY_LABEL_LOG_OUT]:"退出",
    [KEYS.L18N_KEY_LABEL_INCLUSIVE_PARTNER]:"包容性合作伙伴",

    [KEYS.L18N_KEY_LABEL_ABOUT_CISCO]:"关于思科",
    [KEYS.L18N_KEY_LABEL_CONTACT_US]:"联系我们",
    [KEYS.L18N_KEY_LABEL_CAREERS]:"职业",
    [KEYS.L18N_KEY_LABEL_MEET_OUR_PARTNERS]:"认识我们的合作伙伴",
    [KEYS.L18N_KEY_LABEL_FEEDBACK]:"反馈",
    [KEYS.L18N_KEY_LABEL_HELP]:"帮助",
    [KEYS.L18N_KEY_LABEL_TERMS_AND_CONDITIONS]:"条款和条件",
    [KEYS.L18N_KEY_LABEL_PRIVACY_STATEMENT]: '隐私声明',
    [KEYS.L18N_KEY_LABEL_COOKIES]:"饼干",
    [KEYS.L18N_KEY_LABEL_TRADEMARKS]:"商标",
    [KEYS.L18N_KEY_LABEL_SUPPLY_CHAIN_TRANSPARENCY]:"供应链透明度",
    [KEYS.L18N_KEY_LABEL_SITEMAP]:"站点地图",

    [KEYS.L18N_KEY_LABEL_ABOUT_CISCO]: "关于思科",
    [KEYS.L18N_KEY_LABEL_CONTACT_US]: "联系我们",
    [KEYS.L18N_KEY_LABEL_CAREERS]: "职业",
    [KEYS.L18N_KEY_LABEL_MEET_OUR_PARTNERS]: "认识我们的合作伙伴",
    [KEYS.L18N_KEY_LABEL_FEEDBACK]: "反馈",
    [KEYS.L18N_KEY_LABEL_HELP]: "帮助",
    [KEYS.L18N_KEY_LABEL_TERMS_AND_CONDITIONS]: "条款和条件",
    [KEYS.L18N_KEY_LABEL_PRIVACY_STATEMENT]: "隐私声明",
    [KEYS.L18N_KEY_LABEL_COOKIES]: "饼干",
    [KEYS.L18N_KEY_LABEL_TRADEMARKS]: "商标",
    [KEYS.L18N_KEY_LABEL_SUPPLY_CHAIN_TRANSPARENCY]: "供应链透明度",
    [KEYS.L18N_KEY_LABEL_SITEMAP]: "站点地图",
    [KEYS.L18N_KEY_LABEL_HOW_TO_BUY]: "如何购买",
    [KEYS.L18N_KEY_LABEL_PARTNERS]: "合作伙伴",
    [KEYS.L18N_KEY_LABEL_PRODUCTS_AND_SERVICES]: "产品和服务",
    [KEYS.L18N_KEY_LABEL_SOLUTIONS]: "解决方案",
    [KEYS.L18N_KEY_LABEL_SUPPORT]: "支持",
    [KEYS.L18N_KEY_LABEL_LEARN]: "学习",
    [KEYS.L18N_KEY_LABEL_EXPLORE_CISCO]: "探索思科",
    [KEYS.L18N_KEY_LABEL_MENU]: "菜单",
    [KEYS.L18N_KEY_LABEL_CLOSE]: "关闭",
    [KEYS.L18N_KEY_LABEL_SEE_MORE]: "查看更多",
    [KEYS.L18N_KEY_LABEL_SEE_LESS]: "少看",
    [KEYS.L18N_KEY_LABEL_DONT_HAVE_AN_ACCOUNT]: "没有账户？",
    [KEYS.L18N_KEY_LABEL_SIGN_UP]: "注册",
  }
});

export default zhCNTranslations;
